import { ScreenWidthType } from 'components/types'
import {
  CountryType,
  ErrorType,
  ModalType,
  NotificationType,
  UsStateType,
  VeriffMetadataType
} from 'data/types'
// eslint-disable-next-line import/no-duplicates
import addSeconds from 'date-fns/add_seconds'
// eslint-disable-next-line import/no-duplicates
import isFuture from 'date-fns/is_future'
import isEqual from 'lodash/isEqual'
import omit from 'lodash/omit'
import { LanguageType } from 'providers/ConnectedIntl/languages'

import { AppActionType } from './actions'
import * as AT from './actionTypes'

export type AppStateType = {
  countries?: Array<CountryType>
  language: LanguageType
  modal: ModalType
  modalFullscreen: boolean
  modalLargescreen?: boolean
  notifications: Array<NotificationType>
  ready?: boolean
  usStates?: Array<UsStateType>
  veriffMetadata?: VeriffMetadataType
  veriffMetadataError?: ErrorType
  width: ScreenWidthType
}

const initialState = {
  language: 'en' as LanguageType,
  modal: {
    isDismissable: true,
    name: undefined,
    options: { currency: undefined }
  } as ModalType,
  modalFullscreen: false,
  notifications: [],
  width: 'lg' as ScreenWidthType
}

const app = (state: AppStateType = initialState, action: AppActionType): AppStateType => {
  switch (action.type) {
    case AT.ADD_NOTIF: {
      return {
        ...state,
        notifications: [action.payload.notification, ...state.notifications]
      }
    }

    case AT.HIDE_MODAL: {
      const name = isEqual(state.modal.name, action.payload.name) ? undefined : state.modal.name
      return {
        ...state,
        modal: { ...state.modal, isDismissable: true, name }
      }
    }

    case AT.READY: {
      return {
        ...state,
        ready: true
      }
    }

    case AT.REMOVE_EXPIRED_NOTIF: {
      return {
        ...state,
        notifications: state.notifications.filter(
          (notif) => notif.duration === 0 || isFuture(addSeconds(notif.created, notif.duration))
        )
      }
    }

    case AT.REMOVE_NOTIF: {
      const myId = action.payload.id
      return {
        ...state,
        notifications: state.notifications.filter((notif) => notif.id !== myId)
      }
    }

    case AT.SET_COUNTRIES: {
      return {
        ...state,
        countries: action.payload.countries
      }
    }

    case AT.SET_LANGUAGE: {
      return {
        ...state,
        language: action.payload.language
      }
    }

    case AT.SET_MODAL_DISMISSABLE: {
      return {
        ...state,
        modal: {
          ...state.modal,
          isDismissable: action.payload.isDismissable
        }
      }
    }

    case AT.SET_MODAL_FULLSCREEN: {
      return {
        ...state,
        modalFullscreen: action.payload.fullscreen
      }
    }

    case AT.SET_MODAL_LARGESCREEN: {
      return {
        ...state,
        modalLargescreen: action.payload.largescreen
      }
    }

    case AT.SET_SCREEN_SIZE: {
      if (action.payload.width !== state.width) {
        return {
          ...state,
          width: action.payload.width || state.width
        }
      }

      return state
    }

    case AT.SET_US_STATES: {
      return {
        ...state,
        usStates: action.payload.states
      }
    }

    case AT.SET_VERIFF_METADATA: {
      return {
        ...state,
        veriffMetadata: action.payload.veriffMetadata
      }
    }

    case AT.SET_VERIFF_METADATA_ERROR: {
      return {
        ...state,
        veriffMetadataError: action.payload.veriffMetadataError
      }
    }

    case AT.SHOW_MODAL: {
      return {
        ...state,
        modal: {
          isDismissable: state.modal.isDismissable,
          name: action.payload.name,
          options: action.payload.options ?? {
            currency: undefined
          }
        },
        modalFullscreen: action.payload?.options?.fullscreen ?? false
      }
    }

    default:
      return state
  }
}

export default app
